import React, { useState, useContext } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Row, Col } from 'reactstrap';
import CheckboxInput from '../shared/CheckboxInput/CheckboxInput';
import { SessionContext } from '../../context/SessionContext';
import styles from './ManufacturedAbilityModal.module.css';

const ManufacturedAbilityModal = (props) => {
    const { buttonLabel, className, showModal, updateModal, handleContinueAction } = props;

    const [affirmStatus, setAffirmStatus] = useState(false);
    const [validationCheck, setValidationCheck] = useState(null);
    const { accountName } = useContext(SessionContext);

    const handleContinue = () => {
        if (affirmStatus) {
            setValidationCheck(affirmStatus);
            handleContinueAction();
        } else {
            setValidationCheck(affirmStatus);
        }
    };

    const handleAffirmation = (e) => {
        setAffirmStatus(e.target.checked);
        setValidationCheck(e.target.checked);
    };

    return (
        <div>
            <Modal
                isOpen={showModal}
                toggle={!showModal}
                className='modal-md'
            >
                <ModalHeader toggle={updateModal}>
                    <h4 className='modal-title'>Manufactured Housing Eligibility</h4>
                </ModalHeader>
                <ModalBody>
                    <p>
                        <strong>
                            For manufactured housing to be eligible for coverage, the housing must be attached to a
                            permanent foundation.
                        </strong>
                    </p>
                    <p>
                        A permanent foundation is a site-built foundation constructed of durable materials, such as:
                        concrete, mortared masonry or treated wood. The foundation shall have attachment points to
                        anchor and stabilize the manufactured home to transfer all loads to the underlying soil or rock.
                    </p>
                    <p>
                        <CheckboxInput
                            id='affirmStatement'
                            handleCheck={(e) => handleAffirmation(e)}
                            customClass='m-0'
                            clientId={accountName}
                            defaultChecked={affirmStatus}
                            name='affirmationStatement'
                        >
                            I affirm the manufactured house is attached to a permanent foundation.
                        </CheckboxInput>
                        {validationCheck !== null && !validationCheck && (
                            <div className={styles.inputError}>Please affirm to continue.</div>
                        )}
                    </p>
                </ModalBody>
                <ModalFooter>
                    <div className={styles.buttonContainer}>
                        <button
                            className='btn-secondary'
                            onClick={() => updateModal('cancelAll')}
                        >
                            Cancel Sale
                        </button>
                        <div
                            sm='6'
                            md='6'
                            lg='6'
                            className='btnWrapper'
                        >
                            <button
                                className='btnLink mr-2'
                                onClick={() => updateModal('cancel')}
                            >
                                Cancel
                            </button>
                            <button
                                className='btn-primary'
                                onClick={handleContinue}
                            >
                                Continue
                            </button>
                        </div>
                    </div>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default ManufacturedAbilityModal;
